'use client';

import { OWCategoryPage } from '../interfaces/domain/ow-category-page.modal';
import CategoryPageContext, { CategoryPageBasePath } from './category-page-context';

interface Props {
  children: React.ReactNode;
  categoryPage: OWCategoryPage;
  basePath: CategoryPageBasePath,
}

// -----------------------------------------------------------------------------
const CategoryPageContextProvider = (props: Props): JSX.Element => {
  const { categoryPage , children, basePath } = props;
  return (
    <CategoryPageContext.Provider value={{ categoryPage, basePath }}>
      {children}
    </CategoryPageContext.Provider>
  );
};

export default CategoryPageContextProvider;
